import { LIST_BILLING_TRANSFERS } from '@/data/actions/modules/financial';

export default [
  {
    path: '/financial/billing-transfer',
    component: () => import(/* webpackChunkName: "billing-transfer" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: LIST_BILLING_TRANSFERS,
    },
  },
];
